import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import GridDecoration from '../components/GridDecoration';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="landing-page" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden', padding: '0 20px' }}>
                <div style={{ textAlign: 'center', zIndex: 1, padding: '60px', borderRadius: '24px', background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.05)', maxWidth: '600px', width: '100%' }}>
                    <div style={{ fontSize: '120px', fontWeight: '800', color: 'var(--brand-primary)', lineHeight: '1', marginBottom: '20px', letterSpacing: '-5px', opacity: 0.8 }}>
                        404
                    </div>
                    <h1 style={{ fontSize: '32px', marginBottom: '16px', color: 'white' }}>Mission Aborted</h1>
                    <p style={{ color: 'var(--text-secondary)', fontSize: '18px', marginBottom: '40px', lineHeight: '1.6' }}>
                        The page you are looking for has been moved, deleted, or never existed in this sector of the AI security framework.
                    </p>

                    <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                        <button
                            onClick={() => navigate(-1)}
                            className="btn-secondary"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px' }}
                        >
                            <ArrowLeft size={20} />
                            Go Back
                        </button>
                        <button
                            onClick={() => navigate('/')}
                            className="btn-primary"
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px' }}
                        >
                            <Home size={20} />
                            Return Home
                        </button>
                    </div>
                </div>

                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(var(--brand-primary-rgb), 0.1) 0%, transparent 70%)', pointerEvents: 'none', filter: 'blur(60px)' }}></div>
                <GridDecoration />
            </main>
        </div>
    );
};

export default NotFound;
